module.exports = __webpack_public_path__ + "img/emptystate_small.e87a8ba1.png";